// extracted by mini-css-extract-plugin
export default {"box":"index_box_TomSf","title":"index_title_kHAog"};